var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-494e5b85-027a-4d1e-b253-7cacb4142fad",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.03 25.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-8b0ee25c-f7ac-4a03-9b38-162973314723{stroke:url(#uuid-800865aa-2345-4529-8553-686f1c03622f);}.uuid-8b0ee25c-f7ac-4a03-9b38-162973314723,.uuid-1dc84b0b-c245-4576-b5ab-c16f535ff63e,.uuid-6d38e472-fc40-4719-8d9d-f551c3d01d40{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.uuid-1dc84b0b-c245-4576-b5ab-c16f535ff63e{stroke:url(#uuid-e14ac483-6272-4aef-aaff-728d6296b263);}.uuid-6d38e472-fc40-4719-8d9d-f551c3d01d40{stroke:url(#uuid-13943385-3b57-419d-87f3-c84132bf7ed8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-13943385-3b57-419d-87f3-c84132bf7ed8",
    x1: 3.84,
    y1: 6.67,
    x2: 25.7,
    y2: 19.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4dfcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a040ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d640ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-800865aa-2345-4529-8553-686f1c03622f",
    x1: 3.33,
    y1: -4.31,
    x2: 25.19,
    y2: 8.31,
    xlinkHref: "#uuid-13943385-3b57-419d-87f3-c84132bf7ed8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e14ac483-6272-4aef-aaff-728d6296b263",
    x1: 3.84,
    y1: 17.65,
    x2: 25.7,
    y2: 30.27,
    xlinkHref: "#uuid-13943385-3b57-419d-87f3-c84132bf7ed8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-a179582c-d31f-4f7d-be2c-ff4c3bdee3cf"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-6d38e472-fc40-4719-8d9d-f551c3d01d40",
    d: "m2.51,12.98h24.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-8b0ee25c-f7ac-4a03-9b38-162973314723",
    d: "m2,2h24.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dc84b0b-c245-4576-b5ab-c16f535ff63e",
    d: "m2.51,23.96h24.52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.2c46a13952313ce3e366c811feff0639.svg";
export { ForwardRef as ReactComponent };